import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import './percentage-bar-cell.component.scss';

export interface PercentageBarModel {
    positiveSegment?: PercentageBarSegment;
    neutralSegment?: PercentageBarSegment;
    negativeSegment?: PercentageBarSegment;
    mainText?: string;
}

export interface PercentageBarSegment {
    count: number;
    tooltip?: string;
}

interface PercentageBarDisplaySegment extends PercentageBarSegment {
    className: string;
    percentage: number;
}

@Component({
    selector: 'percentage-bar-cell',
    template: require('./percentage-bar-cell.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PercentageBarCellComponent implements OnInit, OnChanges {
    private totalItems: number;

    @Input() model: PercentageBarModel;

    displaySegments: PercentageBarDisplaySegment[] = [];

    ngOnInit(): void {
        this.computeValues();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.computeValues();
    }

    private computeValues(): void {
        this.totalItems = this.getTotalItems();

        this.displaySegments = [
            this.buildDisplaySegment(this.model.negativeSegment, 'negative'),
            this.buildDisplaySegment(this.model.neutralSegment, 'neutral'),
            this.buildDisplaySegment(this.model.positiveSegment, 'positive'),
        ].filter(x => !!x);
    }

    private buildDisplaySegment(segment: PercentageBarSegment, className: string) : PercentageBarDisplaySegment | null {
        if (!segment) {
            return null;
        }

        const percentage = (segment.count || 0) / this.totalItems * 100;
        const percentageString = (percentage / 100).toLocaleString(undefined, { style: 'percent', maximumFractionDigits: 0 });

        const tooltip = !!segment.tooltip 
            ? `${percentageString} ${segment.tooltip} - (${segment.count})` 
            : `${percentageString} - (${segment.count})`;

        return {
            ...segment,
            tooltip,
            className,
            percentage
        };
    }

    private getTotalItems(): number {
        return this.getSegments()
            .filter(x => !!x)
            .map(x => x.count || 0)
            .reduce((sum, current) => sum += current, 0);
    }

    private getSegments(): (PercentageBarSegment | null)[] {
        return [
            this.model.negativeSegment,
            this.model.neutralSegment,
            this.model.positiveSegment
        ]
    }
}
